import { aboutData } from '@/mocks/home';

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
          关于我们
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
          {aboutData.description}
        </p>
      </div>
    </section>
  );
}